import type { PropsWithChildren, FC } from 'react'
import React from 'react'

import styles from './Calendar.module.css'
import { Cell } from './Cell/Cell'
import { DayWidth } from './DayWidth/DayWidth'
import { GridCell, HalfGridCell } from './GridCell/GridCell'
import { Row } from './Row/Row'

type CompoundProps = {
  Cell: typeof Cell
  GridCell: typeof GridCell
  HalfGridCell: typeof HalfGridCell
  DayWidth: typeof DayWidth
  Row: typeof Row
}

const Calendar: FC<PropsWithChildren> & CompoundProps = ({ children }) => {
  return <div className={styles.Calendar}>{children}</div>
}

Calendar.Cell = Cell
Calendar.GridCell = GridCell
Calendar.HalfGridCell = HalfGridCell
Calendar.DayWidth = DayWidth
Calendar.Row = Row

export default Calendar
